module.exports = __webpack_public_path__ + "media/img/pages/companies/laposte-00927c7661270f467b1d706ae2beaefb.png";